// CDN entry: the blocking bootstrap first, then the browser API on top of it.
import './blocking.ts';
import { xwAnalytics } from './api.js';

window.xwAnalytics = xwAnalytics;
